import React from "react";
import { useTheme } from "../../providers/theme-provider";
import useWindowSize from "../../hooks/use-window-size";
import { useTranslation } from "react-i18next";
import spacings from "../../theme/spacings";
import { fontSizes } from "../../theme/font-sizes";

const FormMobile = () => {
  const { colors } = useTheme();
  const { width } = useWindowSize();
  const isMobile = width < 1024;

  const { t } = useTranslation();

  const paddingLeftRight = isMobile
    ? spacings.leftRightSpacingMobile
    : spacings.leftRightSpacing;

  const paddingTopBottom = isMobile
    ? spacings.topBottomSpacingMobile
    : spacings.topBottomSpacing;

  return (
    <div
      style={{
        backgroundColor: colors.heroBg,
        paddingLeft: paddingLeftRight,
        paddingRight: paddingLeftRight,
        paddingTop: 0,
        paddingBottom: 0,
      }}
      className="max-w-[1400px] mx-auto relative z-40 lg:-mb-16 -mb-10"
      id="contact-small"
    >
      <div className="flex flex-col gap-4">
        <div className="flex gap-6 items-center">
          <h3
            className="font-semibold"
            style={{
              fontSize: fontSizes.heading2,
              color: colors.mainHeading,
            }}
          >
            {t("formHeading")}
          </h3>
          <div
            className="h-[2px] w-[80px]"
            style={{
              backgroundColor: colors.mainHeading,
            }}
          ></div>
        </div>

        <p
          className="max-w-xl mx-auto"
          style={{
            fontSize: fontSizes.body,
            color: colors.mainText,
          }}
        >
          {t("formText")}
        </p>

        <div
          className="p-6 rounded-sm shadow-lg relative z-30 "
          style={{
            backgroundColor: colors.background,
          }}
        >
          <form action="" className="flex flex-col gap-6">
            <div className="flex md:flex-row flex-col justify-between">
              <input
                type="text"
                className="p-3 md:w-96"
                style={{
                  backgroundColor: colors.inputBg,
                }}
                placeholder={t("subjectPlaceholder")}
              />
            </div>

            <div>
              <textarea
                name=""
                id=""
                placeholder={t("messagePlaceholder")}
                rows={4}
                className="p-3 w-full"
                style={{
                  backgroundColor: colors.inputBg,
                  resize: "none",
                }}
              ></textarea>
            </div>
            <button
              className="p-3 w-40 mx-auto"
              style={{
                backgroundColor: colors.mainHeading,
                color: colors.background,
                fontSize: fontSizes.body,
              }}
            >
              {t("send")}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default FormMobile;
